import {isNull} from "@/utils/formatting";
import {mapActions} from "vuex";

export default {
    data() {
        return {
            generalError: false,
        };
    },
    computed: {
        modalId() {
            if (isNull(this.index)) {
                throw "You must supply an index if you want to use EditableByPopupMixin.j";
            }
            return 'edit-modal-' + this.index;
        }
    },
    methods: {
        ...mapActions(['getSurgery', 'updateSurgery', 'editSurgery', 'restoreSurgery']),
        showModal() {
            this.editSurgery();
            this.$bvModal.show(this.modalId);
        },
        closeModal() {
            this.$bvModal.hide(this.modalId);
        },
        cancel() {
            this.restoreSurgery();
            this.closeModal();
        },
    },
};